// Module
var code = `<miscellaneous-transactions-page header-title="\$ctrl.header" form-title="\$ctrl.header | uppercase">
  <form name="\$ctrl.form">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr ng-if="\$ctrl.interbranch">
        <td></td>
        <td>Target branch:</td>
        <td>
          <selectize
            options="\$ctrl.otherBranches"
            ng-model="\$ctrl.targetBranchId"
            config="\$ctrl.targetBranchSelectConfig"
            class="nx-selectize"
            ng-change="\$ctrl.onTargetBranchChange(\$ctrl.targetBranchId)"
            required
          >
          </selectize>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Person name:</td>
        <td>
          <user-select
              ng-model="\$ctrl.transaction.targetUserId"
              users="\$ctrl.approvalUsers"
              ng-required="true"
              ng-disabled="\$ctrl.interbranch && !\$ctrl.targetBranchId"
          >
          </user-select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Amount:</td>
        <td>
          <cash ng-model="\$ctrl.transaction.amount"
                ng-model-options="{ debounce: 100 }"
                ng-required="true"
                min="0.01">
          </cash>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="summary-actions">
      <button
          type="button"
          class="btn btn-warning"
          ng-click="\$ctrl.cancel()">
        Cancel
      </button>
      <button
          type="submit"
          class="btn btn-primary"
          ng-disabled="\$ctrl.form.\$invalid"
          ng-click="\$ctrl.save()">
        Transfer now
      </button>
    </div>
  </form>
</miscellaneous-transactions-page>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/cash-transfer/cash-transfer.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;